module.exports = __webpack_public_path__ + "media/fonts/microgramma_d_extended_bold-webfont-02fd7ff8b0d27552de48b85429446e55.woff2";